import { ControlFactoryProperty } from '../controls/factories/enums';

export const FormEventType = {
  Submit: 'submit',
  Reset: 'reset',
  Change: 'change',
};

export const FormFieldProperty = {
  ...ControlFactoryProperty,
  FormControl: 'formControl',
};

export default {
  FormEventType,
  FormFieldProperty,
};
